<template>
  <div class="home">
    <p>
      We are a premier garment accessories supplier based in Singapore,
       serving customers with excellence since 1997.
    </p>
    <p>
      We strive to build strong partnerships based on confidence and trust,
       and are dedicated to providing high quality products that meet global
       safety and environmental standards.
    </p>
    <p>
      Reach out to us at <a href="mailto:enquiries@wyseex.com">enquiries@wyseex.com</a>.
    </p>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
};
</script>
